<template>
  <div class="relative px-4 pt-16 pb-20 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
    <!-- <back-button /> -->
    <div class="relative mx-auto max-w-7xl">
      <h2
        class="text-2xl font-bold leading-9 tracking-tight text-center tmsk-blue-text"
      >
        Processing Payment
      </h2>
      <div class="grid max-w-lg gap-4 mx-auto mt-12">
        <div class="flex flex-row items-center justify-center">
          <img class="w-48" :src="getAssets(method.imageUrl)" />
        </div>
        <div class="flex flex-row items-center justify-center mt-4 text-center">
          Please complete your payment within 5 minutes.
        </div>
        <div class="flex flex-row items-center justify-center mt-10">
          <div class="w-20 h-20 border-4 border-teal-100 rounded-full loader" />
        </div>
        <h3 class="mt-4 text-xl font-medium text-center tmsk-blue-text">
          We have sent you a request for payment via your PayLah! App.
        </h3>
        <p class="text-center tmsk-blue-text">
          Please click on the notification banner on your device to proceed.
        </p>
        <br />
        <p class="text-center tmsk-blue-text">
          Please do not close this page and confirm the payment in your PayLah!
          App.
        </p>
        <!-- <button
          type="button"
          class="p-2 text-base font-medium leading-6 border border-transparent focus:outline-none"
          @click="() => (leavePaymentShade = true)"
        >
          <p
            class="flex items-center justify-center px-4 py-1 text-base text-white rounded-full tmsk-blue-bg"
          >
            Back
          </p>
        </button> -->
      </div>
    </div>

    <!-- Error modal -->
    <!-- <modal
      :displayModal="errorModal"
      :displayShade="errorShade"
      @hide-all="hideErrorModal"
      @show-modal="errorModal = true"
    >
      <div class="text-center">
        <h2
          class="text-2xl font-bold leading-9 tracking-tight text-center tmsk-blue-text"
        >
          Error while processing payment
        </h2>
        <p
          class="max-w-2xl mx-auto text-base leading-7 text-center tmsk-blue-text"
        >
          {{ errorMessage }}
        </p>
      </div>

      <div class="grid mt-5">
        <span class="flex w-full rounded-full shadow-sm">
          <button
            type="button"
            class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white border border-transparent rounded-full tmsk-blue-bg focus:outline-none sm:text-sm sm:leading-5"
            @click="hideErrorModal"
          >
            Proceed
          </button>
        </span>
      </div>
    </modal> -->

    <!-- Cancel modal -->
    <!-- <modal
      :displayModal="leavePaymentModal"
      :displayShade="leavePaymentShade"
      @hide-all="hidePaymentModal"
      @show-modal="leavePaymentModal = true"
    >
      <div class="text-center">
        <h2
          class="text-2xl font-bold leading-9 tracking-tight text-center tmsk-blue-text"
        >
          By selecting "Proceed", this transaction will be cancelled.
        </h2>
        <p
          class="max-w-2xl mx-auto text-base leading-7 text-center tmsk-blue-text"
        >
          You will have to select another payment mode to complete this order.
        </p>
      </div>

      <div
        class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
      >
        <span class="flex w-full rounded-full shadow-sm sm:col-start-2">
          <button
            type="button"
            class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white border border-transparent rounded-full tmsk-blue-bg focus:outline-none sm:text-sm sm:leading-5"
            @click="handleLeavePayment"
          >
            Proceed
          </button>
        </span>
        <span
          class="flex w-full mt-3 rounded-full shadow-sm sm:mt-0 sm:col-start-1"
        >
          <button
            type="button"
            class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white border border-transparent rounded-full tmsk-blue-bg focus:outline-none sm:text-sm sm:leading-5"
            @click="hidePaymentModal"
          >
            Cancel
          </button>
        </span>
      </div>
    </modal> -->
  </div>
</template>

<script>
import beepAPI from '@/mixins/beepAPI'
import { mapActions } from 'vuex'
// import BackButton from '@/components/BackButton'
// import Modal from '@/components/Modal'
export default {
  name: 'PaylahWeb',
  components: {
    // BackButton,
    // Modal
  },
  mixins: [beepAPI],
  props: {
    uuid: {
      type: String,
      required: true
    },
    method: {
      type: Object,
      required: true
    },
    expiryTimestamp: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      hasTimeout: false,
      // leavePaymentModal: false,
      // leavePaymentShade: false,
      errorMessage: '',
      errorModal: false,
      errorShade: false
    }
  },
  computed: {},
  watch: {
    errorMessage (newValue) {
      if (newValue) this.errorShade = true
    }
  },

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    this.commencePolling()
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    ...mapActions(['updateSuccessfulPurchase']),

    commencePolling () {
      this.$rollbar.debug(`[PaylahWeb] Commenced polling for transaction with UUID: ${this.uuid}`)
      const body = {
        uuid: this.uuid,
        expiryTimestamp: this.expiryTimestamp
      }

      this.getPaymentStatus(body)
        .then(
          async response => {
            this.$rollbar.debug(`[PaylahWeb] Received 200 when polling for transaction with UUID: ${this.uuid}`)
            const { status } = response
            if (status === 'success') {
              this.$rollbar.debug(`[PaylahWeb] Transaction with UUID: ${this.uuid} is successful`)
              await this.updateSuccessfulPurchase(response)
              this.$emit('success')
            } else if (status === 'cancelled') {
              if (!this.hasTimeout) {
                this.hasTimeout = true
                this.createModal({
                  title: 'Something went wrong',
                  message: 'Transaction has timed-out or was cancelled, We\'re redirecting back to your Order Summary.',
                  btnMessage: 'Proceed',
                  callback: () => {
                    this.$emit('failed')
                  }
                })
              }
            } else {
              setTimeout(this.commencePolling, 1000)
            }
          },
          (error) => {
            if (!error.response || error.response.status === 0) {
              this.$rollbar.debug(`[PaylahWeb] Network error when polling for transaction status with UUID: ${this.uuid}`)
              this.commencePolling()
            } else {
              this.createModal({
                title: 'Something went wrong',
                message: 'Transaction has timed-out or was cancelled, We\'re redirecting back to your Order Summary.',
                btnMessage: 'Proceed',
                callback: () => {
                  this.$emit('failed')
                }
              })
            }
          }
        )
    },

    getAssets (img) {
      if (!img) return
      return require('@/assets/img/' + img)
    },

    // handleLeavePayment () {
    //   this.leavePaymentModal = false
    //   this.leavePaymentShade = false
    //   this.$emit('failed')
    // },

    // hidePaymentModal () {
    //   this.leavePaymentModal = false
    //   this.leavePaymentShade = false
    // },

    hideErrorModal () {
      this.errorModal = false
      this.errorShade = false
      this.$emit('failed')
    }
  }
}
</script>

<style scoped>
.loader {
  border-top-color: #16bdca;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
